// components/Hero.js
import React from "react";
import { chakra as c, Button, Heading, Text } from "@chakra-ui/react";

export default function Hero() {
  return (
    <c.section
      position="relative"
      width="100%"
      minH="50vw"
      bgImage="url('bg01.png')"
      bgPos="right"
      bgSize="70%"
      bgRepeat="no-repeat"
      display="flex"
      alignItems="center"
      justifyContent="flex-start"
      id="hero"
    >
      {/* 半透明のオーバーレイ */}
      <c.div
        bg="rgba(255, 255, 255, 0.8)"
        py={{ base: 6, md: 10 }}
        px={{ base: 1, md: 8 }}
        width="50%"
        borderRadius="md"
        textAlign="left"
        maxW="1000px"
      >
        <Heading
          fontSize={{ base: "xs", md: "md" }}
          mb={4}
          pl="5%"
          lineHeight="1.4"
          color="gray.700"
        >
          助産院向けSaaSアプリ <br />
          <c.div
          fontSize={{ base: "3xl", md: "5xl", lg: "8xl" }}
          color="brand.500"
          >
          <Text fontFamily='"Chalkboard SE", "Comic Sans MS", cursive'>Manary</Text></c.div>
        </Heading>
        <Text fontSize={{ base: "xs", md: "md", lg: "lg" }} mb={6} color="gray.600" pl="10%">
          予約・問診票・電子カルテを一つにまとめた <br />
          忙しい助産師のための効率化アプリ          
        </Text>
        <Button
          as="a"
          href="#contact"
          bg="brand.500"
          color="white"
          size={{ base: "sm", md: "md", lg: "lg" }}
          _hover={{ bg: "brand.600" }}
          ml="10%"
        >
          無料でお試し
        </Button>
      </c.div>
    </c.section>
  );
}
